export default function Footer() {
  return (
    <footer>
      <div className="footer-bottom">
        <div>© 2026 Folk Cargo Solutions Pvt. Ltd.</div>
        <div>Customs · Ocean Freight · Air Freight · Road Freight · Warehousing</div>
      </div>
      <div className="footer-wordmark" aria-hidden="true"><span>FOLK CARGO</span></div>
    </footer>
  );
}
